import { render } from "./index.vue?vue&type=template&id=f60e4064&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=f60e4064&lang=less&scoped=true"
import "./index.vue?vue&type=style&index=1&id=f60e4064&lang=less"
script.render = render
script.__scopeId = "data-v-f60e4064"

export default script